import { AppConfigKey, setTimestampToUrl } from '@frontend/profilum-components';
import { appConfig, YM } from '@pflm-shared';

const setClientConfigs = () => {
  appConfig.setValue(AppConfigKey.IS_LNR, 'false');
  appConfig.setValue(AppConfigKey.WITHOUT_PROFILUM_BRAND, 'false');
  appConfig.setValue(AppConfigKey.YANDEX_METRIC_ID, PFLM.YANDEX_METRIC_ID);
  appConfig.setValue(AppConfigKey.YANDEX_METRIC_ENABLED, PFLM.YANDEX_METRIC_ENABLED);
  appConfig.setValue(AppConfigKey.BACKEND_GATEWAY_DOMAIN, PFLM.BACKEND_GATEWAY_DOMAIN);
  appConfig.setValue(AppConfigKey.BACKEND_B2G_DOMAIN, PFLM.BACKEND_B2G_DOMAIN);
  appConfig.setValue(AppConfigKey.BACKEND_FRONTEND_DOMAIN, PFLM.BACKEND_FRONTEND_DOMAIN);
  appConfig.setValue(AppConfigKey.BACKEND_API_SURVEY_DOMAIN, PFLM.BACKEND_API_SURVEY_DOMAIN);
  appConfig.setValue(AppConfigKey.BACKEND_IDENTITY_DOMAIN, PFLM.BACKEND_IDENTITY_DOMAIN);
  appConfig.setValue(AppConfigKey.API_SURVEY_IMAGE_URL, PFLM.API_SURVEY_IMAGE_URL);
  appConfig.setValue(AppConfigKey.S3_URL, PFLM.S3_URL);
  appConfig.setValue(AppConfigKey.B2GNEW_REMOTE_ENTRY, setTimestampToUrl(PFLM.B2GNEW_REMOTE_ENTRY));
  appConfig.setValue(AppConfigKey.CLASSES_REMOTE_ENTRY, setTimestampToUrl(PFLM.CLASSES_REMOTE_ENTRY));
  appConfig.setValue(AppConfigKey.LESSONS_REMOTE_ENTRY, setTimestampToUrl(PFLM.LESSONS_REMOTE_ENTRY));
  appConfig.setValue(AppConfigKey.MATERIALS_REMOTE_ENTRY, setTimestampToUrl(PFLM.MATERIALS_REMOTE_ENTRY));
  appConfig.setValue(AppConfigKey.PARENTMAIN_REMOTE_ENTRY, setTimestampToUrl(PFLM.PARENTMAIN_REMOTE_ENTRY));
  appConfig.setValue(AppConfigKey.RESULTS_REMOTE_ENTRY, setTimestampToUrl(PFLM.RESULTS_REMOTE_ENTRY));
  appConfig.setValue(AppConfigKey.STATISTICS_REMOTE_ENTRY, setTimestampToUrl(PFLM.STATISTICS_REMOTE_ENTRY));
  appConfig.setValue(AppConfigKey.PROFESSIONS_REMOTE_ENTRY, setTimestampToUrl(PFLM.PROFESSIONS_REMOTE_ENTRY));
  appConfig.setValue(AppConfigKey.SURVEY_REMOTE_ENTRY, setTimestampToUrl(PFLM.SURVEY_REMOTE_ENTRY));
  appConfig.setValue(AppConfigKey.USER_EXPERIENCE_REMOTE_ENTRY, setTimestampToUrl(PFLM.USER_EXPERIENCE_REMOTE_ENTRY));
  appConfig.setValue(AppConfigKey.LOGIN_AND_REGISTRATION_REMOTE_ENTRY, setTimestampToUrl(PFLM.LOGIN_AND_REGISTRATION_REMOTE_ENTRY));
  appConfig.setValue(AppConfigKey.HOST_REMOTE_ENTRY, setTimestampToUrl(PFLM.HOST_REMOTE_ENTRY));
  appConfig.setClientConfigs();
  YM.init({ ymId: Number(PFLM.YANDEX_METRIC_ID), enabled: PFLM.YANDEX_METRIC_ENABLED === 'true' });
};

export { setClientConfigs };
